import { X } from "lucide-react";
import { useEditHistory } from "../api/chatApi";

interface EditHistoryModalProps {
  roomId: string;
  messageId: string;
  onClose: () => void;
}

function formatTs(iso: string): string {
  try {
    return new Date(iso).toLocaleString("pl-PL");
  } catch {
    return iso;
  }
}

export function EditHistoryModal({
  roomId,
  messageId,
  onClose,
}: EditHistoryModalProps) {
  const history = useEditHistory(roomId, messageId);
  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white border border-gray-200 rounded-md w-full max-w-lg shadow-xl flex flex-col max-h-[80vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-3 border-b border-gray-200">
          <h3 className="text-sm font-mono font-semibold">
            Historia edycji wiadomości
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded"
          >
            <X size={16} />
          </button>
        </div>
        <div className="p-3 overflow-y-auto">
          {history.isLoading && (
            <div className="text-xs text-gray-500">Wczytuję…</div>
          )}
          {!history.isLoading && history.data?.length === 0 && (
            <div className="text-xs text-gray-500">Brak edycji.</div>
          )}
          {history.data?.map((h) => (
            <div
              key={h.id}
              className="border border-gray-200 rounded p-2 mb-2 text-sm"
            >
              <div className="text-[11px] text-gray-500 mb-1">
                {formatTs(h.edited_at)} —{" "}
                {h.edited_by?.full_name || h.edited_by?.username || "—"}
              </div>
              <div className="whitespace-pre-wrap break-words text-gray-900">
                {h.previous_body}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
